module.exports = __webpack_public_path__ + "static/EnmTX_BosForestBoss_L_A_cl-2760c7a6929aa6a533af52261bdb6827.gif";